import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import classNames from "classnames";
import { Link } from "@reach/router";

import Drawer from "@material-ui/core/Drawer";

import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";
import TheatersIcon from "@material-ui/icons/Theaters";
import PlayIcon from "@material-ui/icons/PlayCircleFilled";

class NestedList extends React.Component {
  state = {
    open: true
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  render() {
    const { classes, isOpen, videos = [], live, pathname } = this.props;
    return (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !isOpen && classes.drawerPaperClose
          )
        }}
        open={isOpen}
      >
        <div className={classes.toolbarIcon} />
        <Divider />
        <List
          subheader={
            <ListSubheader
              component="div"
              inset
              className={classes.listSubHeader}
            >
              <Typography variant="subheading" gutter="true">
                <b>Menu</b>
              </Typography>
            </ListSubheader>
          }
          disablePadding
        >
          <Divider />
          <Tooltip
            title="Click to watch Live Streaming"
            placement="right"
            classes={{
              popper: classes.htmlPopper,
              tooltip: classes.htmlTooltip
            }}
            TransitionComponent={Zoom}
          >
            <MenuItem
              selected={"/main/video/live" === pathname}
              component={Link}
              to={`video/live`}
              button
              classes={{ selected: classes.selected }}
            >
              <ListItemIcon>
                <PlayIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="subheading">{`${live.name}`}</Typography>
              </ListItemText>
            </MenuItem>
          </Tooltip>
          {videos.length > 0 && (
            <Fragment>
              <Tooltip
                title="Select video to watch recorded session"
                placement="right"
                classes={{
                  popper: classes.htmlPopper,
                  tooltip: classes.htmlTooltip
                }}
                TransitionComponent={Zoom}
              >
                <MenuItem
                  button
                  onClick={this.handleClick}
                  classes={{
                    selected: classes.selected
                  }}
                >
                  <ListItemIcon>
                    <TheatersIcon />
                  </ListItemIcon>
                  <ListItemText inset={false}>
                    <Typography variant="subheading">Previous Days</Typography>
                  </ListItemText>
                  {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </MenuItem>
              </Tooltip>
              <Collapse in={this.state.open} unmountOnExit>
                <List component="div" disablePadding>
                  {videos.map((video, index) => {
                    return (
                      <Fragment key={index}>
                        <MenuItem
                          selected={`/main/video/${video.key}` === pathname}
                          component={Link}
                          to={`video/${video.key}`}
                          divider={true}
                          button
                          classes={{
                            selected: classes.selected
                          }}
                        >
                          <ListItemText inset>
                            <Typography variant="subheading">
                              {`${video.name}`}
                            </Typography>
                          </ListItemText>
                        </MenuItem>
                      </Fragment>
                    );
                  })}
                </List>
              </Collapse>
            </Fragment>
          )}
        </List>
      </Drawer>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default NestedList;
// export default withStyles(styles)(NestedList);

// const SideBar = ({ classes, isOpen, videos = [], live }) => {
//     return (
//       <Drawer
//         variant="permanent"
//         classes={{
//           paper: classNames(
//             classes.drawerPaper,
//             !isOpen && classes.drawerPaperClose
//           )
//         }}
//         open={isOpen}
//       >
//         <div className={classes.toolbarIcon} />
//         <Divider />
//         <List>
//           <ListItem component={Link} to={`video/${live}`} button>
//             <ListItemText primary="Live" />
//           </ListItem>
//         </List>
//         <Divider />
//         {videos.length > 0 && (
//           <Fragment>
//             <List>
//               <ListSubheader color="primary" inset={false}>
//                 Archive
//                 {videos.map((video, index) => {
//                   return (
//                     <Fragment key={index}>
//                       <ListItem
//                         component={Link}
//                         to={`video/${video.id}`}
//                         divider={true}
//                         button
//                       >
//                         <ListItemText primary={`${video.name}`} />
//                       </ListItem>
//                     </Fragment>
//                   );
//                 })}
//               </ListSubheader>
//             </List>
//           </Fragment>
//         )}
//       </Drawer>
//     );
//   };



// WEBPACK FOOTER //
// ./src/components/common/SideBar.js